const CSP_STYLE_ATTR = 'data-csp-style'

/**
 * 将 HTML 字符串中的 style 属性改写为 data-csp-style，避免 innerHTML 解析时触发 CSP。
 * （style-src 不含 'unsafe-inline' 时，属性样式会被拦截并刷控制台错误）
 */
export function relocateInlineStylesInHtml(html) {
  if (html == null) return ''
  const source = String(html)
  if (!/\sstyle\s*=/i.test(source)) return source

  return source.replace(/\sstyle\s*=\s*(["'])([\s\S]*?)\1/gi, (_, _quote, value) => {
    const escaped = String(value)
      .replace(/&/g, '&amp;')
      .replace(/"/g, '&quot;')
      .replace(/</g, '&lt;')
    return ` ${CSP_STYLE_ATTR}="${escaped}"`
  })
}

function applyStyleDeclarations(node, raw) {
  if (!raw) return

  for (const part of raw.split(';')) {
    const idx = part.indexOf(':')
    if (idx <= 0) continue
    const prop = part.slice(0, idx).trim()
    let val = part.slice(idx + 1).trim()
    if (!prop || !val) continue

    let priority = ''
    if (/!important\s*$/i.test(val)) {
      val = val.replace(/\s*!important\s*$/i, '').trim()
      priority = 'important'
    }
    try {
      node.style.setProperty(prop, val, priority)
    } catch (_) {
      /* 忽略非法声明 */
    }
  }
}

/**
 * 将 DOM 内 data-csp-style / style 提升为 CSSOM（element.style.setProperty）。
 * CSSOM 写入在严格 CSP 下仍可用。
 */
export function promoteInlineStyles(root) {
  if (!root || typeof root.querySelectorAll !== 'function') return

  const nodes = root.querySelectorAll(`[${CSP_STYLE_ATTR}], [style]`)
  for (const node of nodes) {
    const relocated = node.getAttribute(CSP_STYLE_ATTR)
    const raw = relocated != null ? relocated : node.getAttribute('style')
    if (raw) applyStyleDeclarations(node, raw)

    if (node.hasAttribute(CSP_STYLE_ATTR)) node.removeAttribute(CSP_STYLE_ATTR)
  }
}

/**
 * 解析 HTML 片段：先挪走 style 属性，避免 DOMParser 触发 style-src CSP，
 * 再把样式写回 CSSOM。
 * @returns {{ doc: Document, root: HTMLElement } | null}
 */
export function parseHtmlFragment(html, wrapperId = '__csp_root') {
  if (typeof DOMParser === 'undefined') return null
  const id = String(wrapperId || '__csp_root')
  try {
    const safeHtml = relocateInlineStylesInHtml(html)
    const doc = new DOMParser().parseFromString(`<div id="${id}">${safeHtml}</div>`, 'text/html')
    const root = doc.getElementById(id)
    if (!root) return null
    promoteInlineStyles(root)
    return { doc, root }
  } catch {
    return null
  }
}
